import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@foundation/components/ui/table";
import { Button } from "@foundation/components/ui/button";
import { Badge } from "@foundation/components/ui/badge";
import { Pencil, Trash2 } from "lucide-react";
import type { ClientRecord } from "../types/clientTypes";

type ClientTableProps = {
  clients: ClientRecord[];
  onEdit: (client: ClientRecord) => void;
  onDelete: (client: ClientRecord) => void;
};

export const ClientTable = ({ clients, onEdit, onDelete }: ClientTableProps) => {
  if (clients.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
        <p className="text-lg font-medium">No clients found</p>
        <p className="text-sm">Add your first client to get started.</p>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Client Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Address</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {clients.map((client) => (
            <TableRow key={client.id}>
              <TableCell className="font-medium">{client.client_name || "—"}</TableCell>
              <TableCell>{client.email || "—"}</TableCell>
              <TableCell>{client.phone || "—"}</TableCell>
              <TableCell>{client.address || "—"}</TableCell>
              <TableCell>
                <Badge variant={client.status === "Active" ? "default" : "outline"}>
                  {client.status}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <div className="flex justify-end gap-2">
                  <Button variant="ghost" size="icon" onClick={() => onEdit(client)} title="Edit client">
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="icon" onClick={() => onDelete(client)} title="Delete client">
                    <Trash2 className="h-4 w-4 text-destructive" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
